<template>
  <div class="reveil-timer" v-if="this.time">
    <span class="monospace-digit" v-for="(char) in this.time.split('')">{{char}}</span>
  </div>
</template>

<script>
import scTime from '@/util/sc_time';

export default {
  name: 'Timer',
  props: ['startTime', 'endTime'],
  data() {
    return {
      time: this.time,
    };
  },
  mounted() {
    this.interval = setInterval(() => {
      this.updateTime();
    }, 1000);
    this.updateTime();
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    updateTime() {
      const secsNow = scTime({ startTime: this.startTime, endTime: this.endTime });
      const secondsSinceStart = secsNow - this.startTime;
      
      if (secondsSinceStart > 86400) {
        this.time = 'Coda';
        return;
      }

      const hours = Math.floor(secondsSinceStart / 60 / 60);
      const minutes = Math.floor(secondsSinceStart / 60) - (hours * 60);
      const seconds = secondsSinceStart % 60;

      if (!isNaN(hours) && !isNaN(minutes) && !isNaN(seconds)) {
        this.time = [hours, minutes, seconds].map(n => (n < 10 ? `0${n}` : n)).join(':');
      }
      else {
        this.time = "00:00:00";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Timer.vue